import type { ButtonParams } from "viewModels/confirmDialogViewModel";
import ConfirmDialogViewModel from "viewModels/confirmDialogViewModel";
import type LocalizationService from "./localizationService";
import { asString } from "utils/helpers";
import type ModalService from "./modalService";

export type ConfirmationOptions = {
  title?: string;
  confirmButton?: string | ButtonParams;
  cancelButton?: string | ButtonParams;
};

export default class ConfirmationService {
  constructor(private localizationService: LocalizationService, private modalService: ModalService) {}

  async showConfirmation(message: string, { title, confirmButton, cancelButton }: ConfirmationOptions = {}) {
    const confirmButtonParams = {
      text:
        (confirmButton as ButtonParams)?.text ??
        asString(confirmButton) ??
        this.localizationService.translateGeneral("confirmDialog.confirm"),
      variant: (confirmButton as ButtonParams)?.variant ?? "primary",
    } as ButtonParams;

    const cancelButtonParams = {
      text:
        (cancelButton as ButtonParams)?.text ??
        asString(cancelButton) ??
        this.localizationService.translateGeneral("confirmDialog.cancel"),
      variant: (cancelButton as ButtonParams)?.variant ?? "light",
    } as ButtonParams;

    const viewModel = new ConfirmDialogViewModel(message, title ?? undefined, confirmButtonParams, cancelButtonParams);
    await this.modalService.tryActivateChild(viewModel);

    const result = await viewModel.showConfirmation();
    this.modalService.closeChild(viewModel);

    return result;
  }

  deleteConfirmation(message: string = this.localizationService.translateGeneral("confirmDialog.deleteConfirm")) {
    return this.showConfirmation(message, {
      confirmButton: { variant: "danger", text: this.localizationService.translateGeneral("confirmDialog.delete") },
    });
  }
}
